import BaseEntity from '@/editor/entities/BaseEntity';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { EEntityType } from '@/editor/types';

export abstract class OperateAbstract<T extends EEntityType = EEntityType.Base> {
  abstract checkedEntity: BaseEntity<T> | null | undefined;

  moving: boolean = false;
  pickPoint: IPoint2d | null | undefined = null;

  startMove(_point: IPoint2d) {}

  /** 方向键微移：按偏移量更新虚拟模型，不走吸附。只有支持微移的实体才实现 */
  moveByOffset(_offset: IPoint2d) {}

  // 返回吸附点或吸附点与旋转角度
  abstract move(point: IPoint2d): void;
  abstract completeMove(point: IPoint2d): void;
  abstract clear(): void;
  abstract dispose(): void;
}
